import { Component, inject, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GetDictionaryDTO } from 'src/app/Common/common.interface';
import { ValueListService } from 'src/app/Common/ValueListService/value-list.service';
import { ERPEntityMappingService } from 'src/app/erp/ERPEntityMapping.service';
import { IndHierarchyDTO, IndHierarchyList, IndHierarchyUpdateRequestDTO } from 'src/app/ERP/HRMS/indhierarchy.interface';
import { IndHierarchyService } from 'src/app/ERP/HRMS/indhierarchy.service';

interface LevelItem {
  key: string;
  value: string;
}

@Component({
  selector: 'app-hrms-reporting-management',
  templateUrl: './hrms-reporting-management.component.html',
  styleUrls: ['./hrms-reporting-management.component.css']
})
export class HrmsReportingManagementComponent implements OnInit {
  isSubmitLoading = false;          // loading state for submit
  modalTitle = 'Assign Reporting Person';  // dynamic header
  submitButtonText = 'Create';             // dynamic button text

  erpEntityMappingService = inject(ERPEntityMappingService);

  isEditMode = false;
  indId: number | null = null
  userErpId: number | null = null
  selectedHierarchy!: IndHierarchyDTO | null;

  toastr = inject(ToastrService)
  valuelistService = inject(ValueListService)
  modalService = inject(NgbModal)
  levelList: LevelItem[] = [];

  @ViewChild('reportingManagerModal') credentialModal!: TemplateRef<any>;
  modalRef: any;
  indHierarchyService = inject(IndHierarchyService)
  @Input() companyId!: number;
  @Input() userId!: number;
  userReportingForm = new FormGroup({
    indHierarchyId: new FormControl(0),
    userId: new FormControl(0),
    levelId: new FormControl('', [Validators.required]),

    reportingManager1: new FormControl(''),
    reportingManager2: new FormControl(''),
    reportingManager3: new FormControl(''),
  });
  managerList: GetDictionaryDTO[] = [];


  ngOnInit() {
    this.getHLevelList()
    this.userReportingForm.get('levelId')?.valueChanges.subscribe(levelId => {
      if (levelId) {
        this.onLevelChange(levelId);
      }
    });


  }


  getHLevelList() {
    const valuelistPayload = {
      vlCode: 'HL'
    };
    this.valuelistService.ValueListItem_readByVlCode(valuelistPayload).subscribe({
      next: (vlData) => {
        this.levelList = (vlData?.items || []).map((item: any) => ({
          key: item.vliCode,     // "1"
          value: item.vliName    // "L1"
        }));
      },
      error: () => {
        console.log('theere is error in loading valuelist of heirarchy')
      }
    })
  }
  getIndId(userId: number) {
    if (userId) {
      const payload = {
        masterType: 'User',
        masterId: userId
      };

      this.erpEntityMappingService.ERPEntityMapping_ReadByMasterId(payload).subscribe({
        next: (res) => {
          if (res?.items?.length > 0) {
            this.indId = res.items[0].branchId;
            this.userErpId = res.items[0].erpId;
            this.checkIndHierarchyExists();
          } else {
            console.log('Couldn’t find user data, cannot submit teh data ');
          }
        },
        error: () => {
          console.log('error while api called');
        }
      });
    }
  }


  onLevelChange(levelId: string) {
    if (!levelId) return;

    this.userReportingForm.patchValue({
      reportingManager1: null,
      reportingManager2: null,
      reportingManager3: null
    });

    this.getReportingManagers(levelId);
  }


  getReportingManagers(levelId: string) {
    if (!this.companyId || this.companyId === 0) {
      this.toastr.warning(' no erp companyId found ')
      return
    }


    this.indHierarchyService.IndHierrachy_GetManagerDictionary(this.companyId.toString(), levelId).subscribe({
      next: (res) => {
        this.managerList = res?.dropDownList || [];
      },
      error: () => {
        this.managerList = [];
      }
    });
  }
  open() {
    this.modalRef = this.modalService.open(this.credentialModal, { size: 'md', backdrop: 'static' });
  }

  onSubmit() {
    if (!this.indId || !this.userErpId) {
      this.toastr.warning('we didnt got the indid or erpuserid');
      return;
    }

    if (this.userReportingForm.invalid) {
      this.userReportingForm.markAllAsTouched();
      return;
    }

    this.isSubmitLoading = true;
    const formValue = this.userReportingForm.value;

    if (this.isEditMode && this.selectedHierarchy) {

      const updatePayload: IndHierarchyUpdateRequestDTO = {
        indHierarchyID: formValue.indHierarchyId!,   // ✅ REQUIRED
        indId: this.indId,
        userId: this.userErpId,
        reportingManager1: formValue.reportingManager1 ? Number(formValue.reportingManager1) : undefined,
        reportingManager2: formValue.reportingManager2 ? Number(formValue.reportingManager2) : undefined,
        reportingManager3: formValue.reportingManager3 ? Number(formValue.reportingManager3) : undefined,
        hLevel: formValue.levelId ?? undefined,
        actionUser: this.userId.toString(),
        isActive: 1                                // ✅ REQUIRED
      };

      this.updateHierarchy(updatePayload);

    } else {

      const createPayload = {
        indId: this.indId,
        userId: this.userErpId,
        reportingManager1: formValue.reportingManager1 ? Number(formValue.reportingManager1) : undefined,
        reportingManager2: formValue.reportingManager2 ? Number(formValue.reportingManager2) : undefined,
        reportingManager3: formValue.reportingManager3 ? Number(formValue.reportingManager3) : undefined,
        hLevel: formValue.levelId,
        actionUser: this.userId.toString()
      };

      this.createHierarchy(createPayload);
    }
  }

  createHierarchy(formData: any) {
    const data = {
      indId: this.userId,
      ...formData
    };

    this.indHierarchyService.IndHierarchy_create(data).subscribe({
      next: () => {
        this.toastr.success('Hierarchy created successfully');
        this.isSubmitLoading = false;
        this.modalRef.close();
      },
      error: () => {
        console.error('Failed to create hierarchy');
        this.isSubmitLoading = false;

      }
    });
  }


  updateHierarchy(indHieReq: IndHierarchyUpdateRequestDTO) {
    this.indHierarchyService.IndHierarchy_update(indHieReq).subscribe({
      next: () => {
        this.toastr.success('Hierarchy updated successfully');
        this.isSubmitLoading = false;

        this.modalRef.close();
      },
      error: () => {
        console.error('Failed to update hierarchy');
        this.isSubmitLoading = false;

      }
    });
  }

  openForUser(userId: number, companyId: number) {
    this.userId = userId;
    this.companyId = companyId;

    this.getIndId(userId);  // trigger hierarchy check
    // open modal
  }


  checkIndHierarchyExists() {
    if (!this.userErpId) return;

    const payload = { userId: this.userErpId };

    this.indHierarchyService.IndHierarchy_readByUserId(payload).subscribe({
      next: (res: any) => {
        if (!res) {
          // If no hierarchy, prepare form for create
          this.openCreate();
          this.open(); // open once here
        } else {
          // If hierarchy exists, prepare form for edit
          this.openEdit(res); // do NOT call open inside openEdit
        }
      },
      error: () => {
        console.error('error while checking existence');
        this.openCreate();
        this.open(); // open once here
      }
    });
  }

  openCreate() {
    this.isEditMode = false;
    this.selectedHierarchy = null;
    this.userReportingForm.reset();
    // ❌ remove this.open() from here
    this.modalTitle = 'Assign Reporting Person';
    this.submitButtonText = 'Create';

  }

  openEdit(data: IndHierarchyDTO) {
    this.isEditMode = true;
    this.selectedHierarchy = data;

    this.userReportingForm.patchValue({
      indHierarchyId: data.indHierarchyID,
      userId: data.userId,
      // Convert hLevel to string if your levelList keys are strings
      levelId: data.hLevel ? data.hLevel.toString() : '',
      reportingManager1: null,
      reportingManager2: null,
      reportingManager3: null
    }, { emitEvent: false });

    this.modalTitle = 'Update Reporting Person'; // update header
    this.submitButtonText = 'Update';

    if (data.hLevel) {
      this.indHierarchyService.IndHierrachy_GetManagerDictionary(this.companyId.toString(), data.hLevel.toString())
        .subscribe({
          next: (res) => {
            // Ensure keys are treated as numbers if your data (60434) is a number
            this.managerList = (res?.dropDownList || []).map(m => ({
              key: m.key.toString(),  // convert to string
              value: m.value
            }));

            // Patch form values as strings too
            this.userReportingForm.patchValue({
              reportingManager1: data.reportingManager1?.toString() ?? null,
              reportingManager2: data.reportingManager2?.toString() ?? null,
              reportingManager3: data.reportingManager3?.toString() ?? null
            }, { emitEvent: false });


            this.open();
          },
          error: () => {
            this.managerList = [];
            this.open();
          }
        });
    } else {
      this.open();
    }
  }

}
